import {createSelector, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'

export const IS_PROFILE_CHAT_OPEN_LS = 'isProfileChatOpen'
export const IS_CHAT_REQUESTS_HIDE = 'isChatRequestsHide'
export const IS_PHOTO_ASKED = 'isPhotoAsked'
export const IS_INTERESTS_ASKED = 'isInterestsAsked'

type initialStateProps = {
  isTrialModalOpen: boolean
  isProfileChatOpen: boolean
  isChatRequestsHide: boolean
  isNewPasswordModal: boolean
  isPhotoAsked?: boolean
  isVerifyEmailModal: boolean
  isInterestsAsked?: boolean
  connectSocket: number
}

const initialState: initialStateProps = {
  isTrialModalOpen: false,
  isProfileChatOpen: true,
  isChatRequestsHide: false,
  isNewPasswordModal: false,
  isPhotoAsked: false,
  isVerifyEmailModal: false,
  isInterestsAsked: false,
  connectSocket: 0
}

export const appModel = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setTrialModalOpen: (state, {payload}: PayloadAction<boolean>) => {
      state.isTrialModalOpen = payload
    },
    setProfileChatOpen: (state, {payload}: PayloadAction<boolean>) => {
      localStorage.setItem(IS_PROFILE_CHAT_OPEN_LS, JSON.stringify({value: payload}))
      state.isProfileChatOpen = payload
    },
    setChatRequestsHide: (state, {payload}: PayloadAction<boolean>) => {
      localStorage.setItem(IS_CHAT_REQUESTS_HIDE, JSON.stringify({value: payload}))
      state.isChatRequestsHide = payload
    },
    setPhotoAsked: (state, {payload}: PayloadAction<boolean>) => {
      localStorage.setItem(IS_PHOTO_ASKED, JSON.stringify({value: payload}))
      state.isPhotoAsked = payload
    },
    setInterestsAsked: (state, {payload}: PayloadAction<boolean>) => {
      localStorage.setItem(IS_INTERESTS_ASKED, JSON.stringify({value: payload}))
      state.isPhotoAsked = payload
    },
    setNewPasswordModalOpen: (state, {payload}: PayloadAction<boolean>) => {
      state.isNewPasswordModal = payload
    },
    setVerifyEmailModalOpen: (state, {payload}: PayloadAction<boolean>) => {
      state.isVerifyEmailModal = payload
    },
    changeConnectSocket: (state) => {
      state.connectSocket = Date.now()
    },
    setDefaultAppState: () => initialState
  }
})

export const {
  setTrialModalOpen,
  setProfileChatOpen,
  setChatRequestsHide,
  setPhotoAsked,
  setInterestsAsked,
  setNewPasswordModalOpen,
  setVerifyEmailModalOpen,
  changeConnectSocket
} = appModel.actions

export const useTrialModal = () => useSelector(
  createSelector(
    (state: RootState) => state.app.isTrialModalOpen,
    (isOpen) => isOpen
  )
)

export const useProfileChat = () => useSelector(
  createSelector(
    (state: RootState) => state.app.isProfileChatOpen,
    (isOpen) => isOpen
  )
)

export const useChatRequestsHide = () => useSelector(
  createSelector(
    (state: RootState) => state.app.isChatRequestsHide,
    (isHide) => isHide
  )
)

export const useNewPasswordModal = () => useSelector(
  createSelector(
    (state: RootState) => state.app.isNewPasswordModal,
    (isOpen) => isOpen
  )
)

export const useVerifyEmailModal = () => useSelector(
  createSelector(
    (state: RootState) => state.app.isVerifyEmailModal,
    (isOpen) => isOpen
  )
)

export const useConnectSocket = () => useSelector(
  createSelector(
    (state: RootState) => state.app.connectSocket,
    (connectSocket) => connectSocket
  )
)